let workerURL = require('./helpers/get-worker-url');
let url = new URL(parcelRequire.resolve("lyHvT"));
module.exports = workerURL(url.toString(), url.origin, false);